import { IsBoolean, IsString } from "class-validator";
import { Expose } from "class-transformer";

export class RelatedDocument {
  @IsString()
  @Expose()
  id!: string;

  @IsString()
  @Expose()
  documentNumber!: string;

  @IsBoolean()
  @Expose()
  isSettled!: boolean;

  @IsBoolean()
  @Expose()
  isSended!: boolean;
}
